'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { loginOrRegister } from '@libs/api-proxy-client';
import type { IdentityUser } from '@libs/common-next';
import { decodeJwtCookie, isAuth0Enabled, useCart, usePageLayout } from '@libs/common-next';
import type { CartUI } from '@libs/common-node';
import { AUTH_COOKIES } from '@libs/core';
import { loginExToken } from '@libs/experience-api';

function getRedirectUrl(pathname?: string) {
    const treatsPath = '/treats-rewards/authenticated';

    if (pathname === '/sign-in') {
        return treatsPath;
    }

    return pathname || treatsPath;
}

export function SignInSSO() {
    const { user, setUser } = usePageLayout();
    const pathname = usePathname() || undefined;
    const router = useRouter();
    const { setCart, enrichCart } = useCart();
    const searchParams = useSearchParams() || undefined;
    const exchangeToken = searchParams?.get('extok') || undefined;

    // TODO: loading state.  Included for use if needed
    const [_, setIsFetching] = useState(false);

    useEffect(() => {
        if (!exchangeToken || isAuth0Enabled()) {
            return;
        }

        async function processExToken() {
            setIsFetching(true);

            try {
                const loginRes = await loginExToken({ user, exchangeToken });

                if (loginRes && 'accessToken' in loginRes) {
                    setUser(decodeJwtCookie<IdentityUser>(AUTH_COOKIES.ACCESS_TOKEN));

                    const accountResponse = await loginOrRegister();
                    if (accountResponse?.updatedCart?.id) {
                        const updatedCart = accountResponse?.updatedCart as CartUI;
                        const enrichedCart = await enrichCart(updatedCart, undefined);
                        setCart(enrichedCart);
                    }

                    router.push(getRedirectUrl(pathname));
                } else {
                    setIsFetching(false);
                }
            } catch (error) {
                setIsFetching(false);
            }
        }

        void processExToken();
    }, [enrichCart, exchangeToken, pathname, router, setCart, setUser, user]);

    return null;
}
